import cmp from './SimpleDropdown'

export default cmp
